$(function () {
    'use-strict';

    const $gameId = $('[name="game_id"]');
    const $gameKey = $('[name="game_key"]');
    const $gameTemplate = $('[name="game_template"]');

    function updateGameSettings() {
        const $option = $gameId.children('option:selected');

        $gameId.children('option:selected');
        $gameKey.val($option.data('game-key'));
        $gameTemplate.val($option.data('game-template'));
    }

    if ($gameId.children().length > 0) {
        $gameId.on('change', (e) => {
            updateGameSettings();
            $gameTemplate.trigger('change');
        });

        updateGameSettings();
    }
});